import { SliderCard } from './SliderCard';

export type { TypeSliderCardProps } from './types';
export default SliderCard;
